<div class="room-header">
  <div class="room-header__title">
    <span>
      {{ roomName | ellipsis: 10 }}
    </span>
  </div>
  @if (adults !== 0) {
    <div class="room-header__details">
      <mb-icon-text>
        <mb-icon icon="adult"></mb-icon>
        <span class="room-header__label">
          {{ adults.toString().concat(' ', adults > 1 ? 'adultos' : 'adulto') }}
        </span>
      </mb-icon-text>

      @if (children !== 0) {
        <span class="separator"> </span>
        <span>
          {{ children.toString().concat(' ', children > 1 ? 'menores' : 'menor') }}
        </span>
      }
    </div>
  }

  @if (beds !== 0) {
    <div class="room-header__details">
      <mb-icon-text>
        <mb-icon icon="product-hotel"></mb-icon>
        <span class="room-header__label">
          {{ beds.toString().concat(' ', beds > 1 ? 'habitaciones' : 'habitación') }}
        </span>
      </mb-icon-text>

      @if (bathrooms !== 0) {
        <span class="separator"> </span>
        <span>
          {{ bathrooms.toString().concat(' ', bathrooms > 1 ? 'baños' : 'baño') }}
        </span>
      }
    </div>
  }
</div>
